import { IconError } from '@gazin/ecommerce-ui'
import { theme } from 'src/styles/themes/default'

export default function UnavailableVariationIndicator() {
  return (
    <IconError
      backgroundColor={theme.colors.white}
      border="transparent"
      borderRadius="3.125rem"
      h="1.1rem"
      position="absolute"
      stroke={theme.colors.grey[400]}
      strokeWidth="4.5px"
      w="1.063rem"
      zIndex="2"
    />
  )
}
